import { GsFormSchema } from '../../../components';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { borderRadiusSchemaFields } from './../basics/border.schema';
import { SWIPER_WITH_GRID_SCHEMA_FIELDS } from './../basics/swiper.schema';
import { teaserBadgeSchemaFields } from './../basics/teaser-badge.schema';
import { SPACING_SCHEMA } from './spacing.schema';
import { DISPLAY_MODE_SCHEMA } from './../basics/display-mode.schema';

export const REPORT_DETAIL_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...BASIC_SCHEMA_FIELDS,
    ...ACTIVE_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...SWIPER_WITH_GRID_SCHEMA_FIELDS,
    {
      formControlName: 'showAuthor',
      label: 'components.reportDetail.schema.showAuthor',
      groupingName: 'components.reportDetail.schema.shownInformations',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showDate',
      label: 'components.reportDetail.schema.showDate',
      groupingName: 'components.reportDetail.schema.shownInformations',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'showShareBar',
      label: 'components.reportDetail.schema.showShareBar',
      groupingName: 'components.reportDetail.schema.shownInformations',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'newForDays',
      label: 'components.searchGallery.schema.newForDays',
      groupingName: 'components.reportDetail.schema.shownArticleInformations',
      type: 'number',
      default: 10,
      min: 1
    },
    {
      formControlName: 'showPhotos',
      groupingName: 'components.reportDetail.schema.shownArticleInformations',
      label: 'components.searchGallery.schema.showPhotos',
      type: 'checkbox',
      default: true
    },
    {
      formControlName: 'itemImageHeight',
      label: 'schema.items.itemImageHeight',
      groupingName: 'components.reportDetail.schema.shownArticleInformations',
      type: 'number',
      isResponsive: true,
      default: { default: 200 },
      if: {
        args: [{ formControlName: 'showPhotos', value: true }]
      }
    },
    ...teaserBadgeSchemaFields({
      groupingName: 'components.reportDetail.schema.shownArticleInformations',
      includeItemTypeBadge: false
    }),
    ...DISPLAY_MODE_SCHEMA,
    ...borderRadiusSchemaFields('', undefined, false, undefined, 'schema.imageRadius')
  ]
};
